import $ from 'jquery'
import { trace } from 'rytm-helpers'
import { Carousel } from 'bootstrap'

const onToggleCarouselPause = (e) => {
  e.preventDefault()
  const trigger = e.currentTarget
  const labelPause = trigger.dataset.label
  const labelPlay = trigger.dataset.labelAlt
  const srOnly = trigger.querySelector("span.sr-only")
  const selector = trigger.getAttribute("href")
  const carouselEl = selector ? document.querySelector(selector) : null
  if (!carouselEl) {
    return false
  }
  trace("toggle carousel cycle")
  const carousel = Carousel.getInstance(carouselEl)
  if (trigger.classList.contains("active")) {
    trigger.classList.remove("active")
    carousel.cycle()
    // update labels
    if (labelPause && labelPlay) {
      trigger.setAttribute("aria-label", labelPause)
      if (srOnly) {
        srOnly.innerHTML = labelPause
      }
    }
  } else {
    trigger.classList.add("active")
    carousel.pause()
    // update labels
    if (labelPause && labelPlay) {
      trigger.setAttribute("aria-label", labelPlay)
      if (srOnly) {
        srOnly.innerHTML = labelPlay
      }
    }
  }
}

export const initBoocarousel = () => {
  $('body').on('click', '.carousel-control-pause', onToggleCarouselPause)
}